// コラム本文の目次(ez-tocプラグイン)の開閉ボタン
// ez-toc側が動的にボタンを差し込むため、イベント委任(document側で監視)にしている
document.addEventListener( "click", function ( event )
{
    const tocButton = event.target.closest( ".ez-toc-btn" );

    if ( !tocButton ) return;

    event.preventDefault();

    const tocContainer = tocButton.closest( ".c-column-table-content" );

    if ( !tocContainer ) return;

    const tocNav = tocContainer.querySelector( "nav" );

    if ( !tocNav ) return;

    const toggleIcon = tocButton.closest( ".ez-toc-title-toggle" );

    tocNav.classList.toggle( "is-open" );

    if ( toggleIcon )
    {
        toggleIcon.classList.toggle( "is-open" );
    }
} );
